module.exports = __webpack_public_path__ + "static/media/metafest-flavortext.83691c67.png";